<script>
import {mapActions, mapState, mapGetters} from 'vuex';
import templatable from "@/mixins/templatable";

// shipping Address inputs
import Gender from "@/components/configuration/profile/profile-information/Gender.vue";
import Initials from "@/components/configuration/profile/profile-information/Initials.vue";
import IdentificationNumber from "@/components/configuration/profile/identification-fields/IdentificationNumber.vue";
import IdentificationType from "@/components/configuration/profile/identification-fields/IdentificationType.vue";
import PlaceOfIssue from "@/components/configuration/profile/identification-fields/PlaceOfIssue.vue";
import DocumentIssueDate from "@/components/configuration/profile/identification-fields/DocumentIssueDate.vue";
import DocumentExpirationDate from "@/components/configuration/profile/identification-fields/DocumentExpirationDate.vue";
import GovernmentIssuedId from "@/components/configuration/profile/identification-fields/GovernmentIssuedId.vue";
import ProofOfAddress from "@/components/configuration/profile/identification-fields/ProofOfAddress.vue";
import EmploymentInformation from "@/components/configuration/profile/identification-fields/EmploymentInformation.vue";
import CompanyIdDocuments from "@/components/configuration/profile/identification-fields/CompanyIdDocuments.vue";

import InterestCheckboxes from "@/components/configuration/profile/InterestCheckboxes.vue";
import VatNumber from "@/components/configuration/profile/customer-terms/VatNumber.vue";
import IdentificationChecked from "@/components/configuration/profile/customer-terms/IdentificationChecked.vue";
import KycStatusApproved from "@/components/configuration/profile/customer-terms/KycStatusApproved.vue";
import BiddingLimit from "@/components/configuration/profile/customer-terms/BiddingLimit.vue";
import PersonalIdentificationDetails from "@/components/configuration/profile/PersonalIdentificationDetails.vue";
import LoadingButton from "@/components/core/LoadingButton.vue";
import DynamicFieldInputs from "@/views/IdentityVerification/DynamicFieldInputs.vue";

export default {
  name: "PersonalIdentificationForm",
  mixins: [templatable('personalIdentificationDetailsTemplate')],
  components: {

    LoadingButton,
    PersonalIdentificationDetails,
    VatNumber,
    IdentificationChecked,
    KycStatusApproved,
    BiddingLimit,
    IdentificationNumber,
    IdentificationType,
    PlaceOfIssue,
    DocumentIssueDate,
    DocumentExpirationDate,
    GovernmentIssuedId,
    ProofOfAddress,
    EmploymentInformation,
    CompanyIdDocuments,
    InterestCheckboxes,
    DynamicFieldInputs,

    Gender,
    Initials
  },
  data: () => ({
    bankAccountFilled: false,
    paymentCompleted: false,
    template: `
      <div v-if="customer" class="ta-profile-body">
      [[template]]
      </div>
    `
  }),
  props: {
    errors: {
      required: false,
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      customer: state => state.customer
    }),
    ...mapGetters(['identificationDynamicFields', 'customerMeta'])
  },
  provide() {
    return {
      disabled: this.disabled
    }
  },
  methods: {
    ...mapActions(["getCountries", "getTitles"]),
    // eraseBankAccount() {
    //   Object.keys(this.model.bank_account).forEach(key => {
    //     this.model.bank_account[key] = ""
    //   });
    // },
  },
  async beforeMount() {
    await this.getCountries();
    await this.getTitles();
  }
}
</script>

<style scoped>

</style>
